import { render, staticRenderFns } from "./TotalReport.vue?vue&type=template&id=73aa6eb4&scoped=true&"
import script from "./TotalReport.vue?vue&type=script&lang=js&"
export * from "./TotalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aa6eb4",
  null
  
)

export default component.exports